export const GET_OPERATIONS_REQUEST = "GET_OPERATIONS_REQUEST";
export const GET_OPERATIONS_SUCCESS = "GET_OPERATIONS_SUCCESS";
export const GET_OPERATIONS_FAILURE = "GET_OPERATIONS_FAILURE";

export const GET_OPERATION_FOR_DROPDOWN_REQUEST =
  "GET_OPERATION_FOR_DROPDOWN_REQUEST";
export const GET_OPERATION_FOR_DROPDOWN_SUCCESS =
  "GET_OPERATION_FOR_DROPDOWN_SUCCESS";
export const GET_OPERATION_FOR_DROPDOWN_FAILURE =
  "GET_OPERATION_FOR_DROPDOWN_FAILURE";

export const CREATE_OPERATIONS_REQUEST = "CREATE_OPERATIONS_REQUEST";
export const CREATE_OPERATIONS_SUCCESS = "CREATE_OPERATIONS_SUCCESS";
export const CREATE_OPERATIONS_FAILURE = "CREATE_OPERATIONS_FAILURE";

export const UPDATE_OPERATIONS_REQUEST = "UPDATE_OPERATIONS_REQUEST";
export const UPDATE_OPERATIONS_SUCCESS = "UPDATE_OPERATIONS_SUCCESS";
export const UPDATE_OPERATIONS_FAILURE = "UPDATE_OPERATIONS_FAILURE";

export const DELETE_OPERATIONS_REQUEST = "DELETE_OPERATIONS_REQUEST";
export const DELETE_OPERATIONS_SUCCESS = "DELETE_OPERATIONS_SUCCESS";
export const DELETE_OPERATIONS_FAILURE = "DELETE_OPERATIONS_FAILURE";

export const GET_LABELS_WITH_PAGINATION_REQUEST =
  "GET_LABELS_WITH_PAGINATION_REQUEST";
export const GET_LABELS_WITH_PAGINATION_SUCCESS =
  "GET_LABELS_WITH_PAGINATION_SUCCESS";
export const GET_LABELS_WITH_PAGINATION_FAILURE =
  "GET_LABELS_WITH_PAGINATION_FAILURE";

export const GET_PRINTERS_FOR_LABEL_REQUEST = "GET_PRINTERS_FOR_LABEL_REQUEST";
export const GET_PRINTERS_FOR_LABEL_SUCCESS = "GET_PRINTERS_FOR_LABEL_SUCCESS";
export const GET_PRINTERS_FOR_LABEL_FAILURE = "GET_PRINTERS_FOR_LABEL_FAILURE";

export const GET_OPERATIONS_BY_PO_REQUEST = "GET_OPERATIONS_BY_PO_REQUEST";
export const GET_OPERATIONS_BY_PO_SUCCESS = "GET_OPERATIONS_BY_PO_SUCCESS";
export const GET_OPERATIONS_BY_PO_FAILURE = "GET_OPERATIONS_BY_PO_FAILURE";
